module.exports = __webpack_public_path__ + "static/img/no_page.49a71a61.png";